// src/api.js
const baseUrl = process.env.NODE_ENV === 'production'
  ? 'https://backend.myevento-digital.com:3000' // Cambiado a HTTPS para producción
  : 'http://localhost:3000';  // URL de desarrollo
console.log('Base URL:', baseUrl);

export default baseUrl;
